import AsyncTaskDeleteModal from './AsyncTaskDeleteModal';
import AsyncConfirmDeleteCommentModal from 'collaboration-sidebar/components/AsyncConfirmDeleteCommentModal';
import AsyncNotificationSettingsModal from './AsyncNotificationSettingsModal';
import { isUngated } from '../utils/auth';
import { ENABLE_ASSET_LEVEL_PREFERENCES } from '../constants/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Modals({
  confirmDeleteCommentModalProps,
  taskDeleteModalProps,
  notificationSettingsModalProps,
  showDeleteCommentModal,
  showTaskDeleteModal,
  showNotificationSettingsModal,
  withoutSidebar,
  isReady,
  IFrameError
}) {
  const isUngatedToSeeNotificationSettings = isUngated(ENABLE_ASSET_LEVEL_PREFERENCES);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDeleteCommentModal && /*#__PURE__*/_jsx(AsyncConfirmDeleteCommentModal, Object.assign({}, confirmDeleteCommentModalProps, {
      withoutSidebar: withoutSidebar,
      isReady: isReady,
      error: IFrameError
    })), showTaskDeleteModal && /*#__PURE__*/_jsx(AsyncTaskDeleteModal, Object.assign({}, taskDeleteModalProps)), showNotificationSettingsModal && isUngatedToSeeNotificationSettings && /*#__PURE__*/_jsx(AsyncNotificationSettingsModal, Object.assign({}, notificationSettingsModalProps))]
  });
}